<template>
  <div class="articles-list__inner fadeIn">
    <template v-for="(item, index) in getItems">
      <div v-if="item.category" :key="`${index}-item`" :class="`article-item ${item.category}`">

        <a :href="item.link" class="article-item__img">
          <img :src="item.imgSrc" :alt="item.imgAlt">
        </a>

        <div class="article-item__content">
          <div class="article-item__header">{{ item.header }}</div>
          <div class="article-item__perex" v-html="item.text"></div>
          <div class="article-item__link">
            <a class="link--btn" :href="item.link">{{ item.detailCaption }}</a>
          </div>
        </div>
      </div>

      <div
        v-else
        :key="`${index}-item`"
        class="sponsored-item"
        :style="{ backgroundColor: item.color }"
      >
        <a :href="item.link" class="sponsored-item__img">
          <img :src="item.img" :alt="item.alt" />
        </a>

        <div class="sponsored-item__name" :style="{ backgroundColor: item.nameColor }">Naše produkty</div>

        <div class="sponsored-item__link">
          <a :href="item.link" class="link--btn btn--slim">{{ item.buttonCaption }}</a>
        </div>

        <div class="sponsored-item__desc">{{ item.desc }}</div>
      </div>
    </template>

    <paginate
      v-if="pageCount > 1"
      :page-count="pageCount"
      @change="(newPage) => page = newPage"
      :next-page-caption="nextPageCaption"
    ></paginate>
  </div>
</template>
<script>
import Paginate from "./components/Pagination.vue";
import { chunk } from "lodash";

export default {
  name: "App",
  components: {
    Paginate
  },

  data: function() {
    return {
      page: 1,
      pageCount: 1,
      category: [],
      tags: [],
      articles: [],
      sponsored: [],
      first: true,

      nextPageCaption: "Next page"
    };
  },

  computed: {
    getArticles: function() {
      let result = this.articles;

      if (this.category.length > 0) {
        result = result.filter(article =>
          this.category.includes(article.category)
        );
      } else {
        return [];
      }

      if (this.tags.length > 0) {
        result = result.filter(
          article =>
            article.tags && article.tags.some(tag => this.tags.includes(tag))
        );
      }

      return result;
    },
    getItems: function() {
      let result = [...this.getArticles];

      this.sponsored.map(item => result.splice(item.position - 1, 0, item));

      result = chunk(result, 12);

      return result[this.page - 1] ? result[this.page - 1] : [];
    }
  },

  watch: {
    getArticles: function(val, oldVal) {
      this.pageCount = Math.ceil(this.getArticles.length / 12);
      if (this.pageCount === 0) this.pageCount = 1;

      if (this.page > this.pageCount) {
        this.page = this.pageCount;
      }
    }
  },

  methods: {
    toggle: function(arr, item, e, categories) {
      if (categories && this.first) {
        this.first = false;

        const categories = document.getElementsByClassName("filter__category");
        for (let category of categories[0].children) {
          category.dataset.category !== item &&
            category.classList.remove("active");
          this.category = [item];
        }

        return;
      }

      let index = arr.indexOf(item);

      if (index !== -1) {
        e.target.classList.remove("active");
        arr.splice(index, 1);
      } else {
        e.target.classList.add("active");
        arr.push(item);
      }
    },
    setCategory: function(e) {
      const category = e.target.dataset.category;
      this.toggle(this.category, category, e, true);
    },
    toggleTag: function(e) {
      const tag = e.target.dataset.tag;
      this.toggle(this.tags, tag, e, false);
    },

    buttonsIterate: function(eventHandler) {
      const categories = document.getElementsByClassName("filter__category");
      const tags = document.getElementsByClassName("filter__tag");

      if (categories[0]) {
        for (let category of categories[0].children) {
          this.category.push(category.dataset.category);
          eventHandler(category, this.setCategory);
        }
      }

      if (tags[0]) {
        for (let tag of tags[0].children) {
          eventHandler(tag, this.toggleTag);
        }
      }
    },

    loadArticles: function() {
      const articles = document.querySelectorAll(
        ".original-items .article-item"
      );

      for (let article of articles) {
        this.articles.push({
          category: article.dataset.category,
          tags: article.dataset.tags.split("|"),
          link: article.querySelector("a").href,
          imgSrc: article.querySelector("a img").src,
          imgAlt: article.querySelector("a img").alt,
          header: article.querySelector(".article-item__header").innerHTML,
          text: article.querySelector(".article-item__perex").innerHTML,
          detailCaption: article.querySelector("a.link--btn").innerHTML
        });

        article.remove();
      }

      const sponsored = document.querySelectorAll(
        ".original-items .sponsored-item"
      );

      for (let sponsoredItem of sponsored) {
        const img = sponsoredItem.querySelector("a img");
        this.sponsored.push({
          color: sponsoredItem.style.backgroundColor,
          link: sponsoredItem.querySelector("a").href,
          img: img.src,
          alt: img.alt,
          name: sponsoredItem.querySelector(".sponsored-item__name").innerHTML,
          nameColor: sponsoredItem.querySelector(".sponsored-item__name").style
            .backgroundColor,
          buttonCaption: sponsoredItem.querySelector(
            ".sponsored-item__link .link--btn"
          ).innerHTML,
          desc: sponsoredItem.querySelector(".sponsored-item__desc").innerHTML,
          position: sponsoredItem.dataset.position
        });
        sponsoredItem.remove();
      }

      this.pageCount = Math.ceil(this.articles.length / 12);
    }
  },

  created() {
    this.buttonsIterate((el, fn) => el.addEventListener("click", fn));
    this.loadArticles();

    this.nextPageCaption = document.querySelector(
      ".articles-pager .articles-pager__btn"
    ).innerHTML;
    document.querySelector(".articles-pager").remove();
  },

  destroyed() {
    this.buttonsIterate((el, fn) => el.removeEventListener("click", fn));
  }
};
</script>

<style>
#app-articles {
  display: flex;
  width: 100%;
}

.articles-list__inner {
  width: 100%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  animation: 1s ease-out 0s 1 fadeIn;
}
</style>
